"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIExternalApiEvent = void 0;
/**
 * Created by Jonas Wålekvist on 2019-11-15.
 */
var APIExternalApiEvent;
(function (APIExternalApiEvent) {
    APIExternalApiEvent["EXIT"] = "exit";
    APIExternalApiEvent["EXIT_REPLAY"] = "exit-replay";
})(APIExternalApiEvent = exports.APIExternalApiEvent || (exports.APIExternalApiEvent = {}));
//# sourceMappingURL=APIExternalApi.js.map